<template>
	<div v-if="!dataSame">
		<old-version-marker/>
		<project-costs-table
			:actions="oldActions"
			:actions-costs="oldActionsCosts"
			:administrative-costs="oldAdministrativeCosts"
			:actions-costs-actions-ids="oldActionsCostsActionsIds"
			:offer-configuration="configuration"
			:readonly="true"
		/>
		<new-version-marker/>
		<project-costs-table
			:actions="currentActions"
			:actions-costs="currentActionsCosts"
			:administrative-costs="currentAdministrativeCosts"
			:actions-costs-actions-ids="currentActionsCostsActionsIds"
			:offer-configuration="configuration"
			:readonly="true"
		/>
		<br>
		<br>
	</div>
</template>

<script>

	import ProjectCostsTable from "@/view/logged/project/components/CostsTableComponents/ProjectCostsTable";
  import OldVersionMarker from "@/view/logged/offer/compareComponents/oldVersionMarker";
  import NewVersionMarker from "@/view/logged/offer/compareComponents/NewVersionMarker";

  export default {
		name: "CompareProjectCostsTable",

    components: {NewVersionMarker, OldVersionMarker, ProjectCostsTable},

    computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.oldActionsCosts) === JSON.stringify(this.currentActionsCosts) &&
					JSON.stringify(this.oldAdministrativeCosts) === JSON.stringify(this.currentAdministrativeCosts);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			configuration: {},

			oldActionsCostsActionsIds: {},
			oldActionsCosts: {},
			oldAdministrativeCosts: {},
			oldActions: {},

			currentActionsCostsActionsIds: {},
			currentActionsCosts: {},
			currentAdministrativeCosts: {},
			currentActions: {},
		}
	};
</script>

<style scoped>

</style>
